import { ReactElement, useContext } from 'react';

import { LoginPage } from '@/components/App/AppLayout/LoginPage';
import { AuthorisedCustomerCompanyUserContext } from '@/contexts/user';

type LoginGatewayProps = {
  children: ReactElement;
};

/**
 * Authorization gate. Authentication is handled upstream by `AuthGateway`
 * (logged out → login page), so by this point the user is signed in. Here we
 * only check they're allowed to view THIS company; if not, show the login page's
 * not-authorised variant (its button signs out so they can switch account).
 */
export const LoginGateway = ({
  children,
}: LoginGatewayProps) => {
  const {
    isCustomerCompanyUserAuthorized,
  } = useContext(AuthorisedCustomerCompanyUserContext);

  if (!isCustomerCompanyUserAuthorized) {
    return <LoginPage isUserNotAuthorisedForThisCompanyError={true} />;
  }

  return (
    <>{children}</>
  );
};
